var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nx-badge",class:_vm.color,style:({ color: _vm.fontColor, backgroundColor: _vm.outline ? 'transparent !important' : '' })},[_c('span',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }